import { toast } from "react-hot-toast";
import * as utilConstants from "../../../utils/constants/utilsConstants";

const renderToastWithClose = (t, message) => (
    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <span>{message}</span>
      <button
        onClick={() => toast.dismiss(t.id)}
        style={{
          background: 'none',
          border: 'none',
          color: 'inherit',
          fontSize: '20px',
          marginLeft: '10px',
          cursor: 'pointer',
          lineHeight: '1'
        }}
      >
        &times;
      </button>
    </span>
  );

export default function ReactNotifications(
    message,
    type = utilConstants.getSuccessStatus,
) {
    switch (type) {
        case utilConstants.getInfoStatus:
            return toast((t) => renderToastWithClose(t, message));
        case utilConstants.getSuccessStatus:
            return toast.success((t) => renderToastWithClose(t, message));
        case utilConstants.getWarningStatus:
            return toast((t) => renderToastWithClose(t, message), {
                icon: '⚠️',
            });
        case utilConstants.getErrorStatus:
            return toast.error((t) => renderToastWithClose(t, message));
        default:
            return toast.success((t) => renderToastWithClose(t, message));
    }
}

export const showApiErrors = (errorResponse) => {
    let errorsData = errorResponse?.data?.errors ||
        errorResponse?.errors ||
        errorResponse?.data ||
        errorResponse;

    const capitalizeFirstLetter = (str) => {
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    const displayErrors = (data, keyName = null) => {
        if (!data) return;

        if (typeof data === 'string') {
            const message = keyName ? `${capitalizeFirstLetter(keyName)}: ${data}` : data;
            ReactNotifications(message, utilConstants.getErrorStatus);
            return;
        }

        if (Array.isArray(data)) {
            data.forEach(item => {
                displayErrors(item, keyName);
            });
            return;
        }

        if (typeof data === 'object' && data !== null) {
            Object.entries(data).forEach(([key, value]) => {
                displayErrors(value, key);
            });
        }
    };

    if (!errorsData || (typeof errorsData === 'object' && Object.keys(errorsData).length === 0)) {
        const message = errorResponse?.data?.message || errorResponse?.message || "Something went wrong!";
        ReactNotifications(message, utilConstants.getErrorStatus);
        return;
    }

    displayErrors(errorsData);
};